import { FC } from "react";
import { Tooltip } from "antd";
import { cn } from "utils";
import { ospThemes } from "@ospweb/sdk-ui";

export const About: FC<{
  desc: string;
  descTooltipText?: string;
  className?: string;
  rootClassName?: string;
}> = ({ desc, descTooltipText, className, rootClassName }) => {
  const Desc = () => {
    return (
      <>
        <div className="px-1 py-[6px] body_s text-content_tertiary">
          {descTooltipText || desc}
        </div>
      </>
    );
  };
  return (
    <Tooltip
      title={<Desc />}
      arrow={false}
      color={ospThemes.colors.background_solid_secondary}
      placement="bottom"
      classNames={{
        root: cn(
          "max-w-[300px] rounded-xl border border-background_white_overlay20 overflow-hidden",
          rootClassName,
        ),
      }}
    >
      <div
        className={cn(
          "max-w-[300px] truncate body_medium_m text-content_primary cursor-pointer",
          className,
        )}
      >
        {desc}
      </div>
    </Tooltip>
  );
};
